<template>  
<div> <!-- root element start -->
	<div class="row">
		<div class="col-12">
      <div v-if="userLatestContactsComp == 0" class="card border-0">
          <div class="card-body">

            <scaling-squares-spinner :animation-duration="2000" :size="65" color="#0E1698" style="margin:auto"/>

          </div>
      </div>
      <div v-if="userLatestContactsComp == 1" class="card border border-dark border-left-0 border-right-0 border-bottom-0 rounded-0 px-0 mx-0 pt-2">

        <div v-if="userLatestContacts.length < 1" class="card-body border-0 mb-0 px-0 pt-0">
          <div class="row">
            <div class="col-12"><span class="h6 font-weight-bold ">Latest Contacts</span></div>
          </div>
          <div class="row mt-2 mb-2">
            <div class="col-12 text-center"><span class="small">No Contact Records Found</span></div>
          </div>

        </div>

        <div v-if="userLatestContacts.length > 0" class="card-body border-0 mb-0 px-0 pt-0">
          <div class="row">
            <div class="col-12"><span class="h6 font-weight-bold ">Latest Contacts</span></div>
          </div>
          <div v-for="(cont,index) in userLatestContacts" class="card mb-1">
            <div class="card-body p-2">
              <div class="row">
                <div class="col-12 text-truncate">
                  <a :href="detailUrl + cont.id" class="mr-2"><i class="fa fa-search" aria-hidden="true"></i></a>
                  <small class="font-weight-bold ">{{ cont.f_name }} {{ cont.l_name }}</small>

                </div>
              </div>
              
              <div class="row">
                <div class="col-12 text-truncate">

                  <small class="">{{ cont.org.name }}</small>
                </div>
              </div>
            </div>
          </div>

        </div>


      </div>


		</div>
	</div>
</div> <!-- root element end -->
</template>

<style>
.vuetable :focus { outline:none; }
.vuetable thead { display: none; }
</style>

<script>
import { ScalingSquaresSpinner } from 'epic-spinners'
import {store} from '../../stores/user-dashboard-main-store.js'




export default {
  store,
  data: function () {
    return { 
      detailUrl: '/contact-detail/',
    }
  },
  computed: {
    userLatestContacts() { return this.$store.state.userLatestContacts; },
    userLatestContactsComp() { return this.$store.state.userLatestContactsComp; }
  },
  watch: {
    
  },
  mounted() {

  },
  methods: {
    changeRightView(name, prop1, prop2, prop3) { this.$store.dispatch("getRightView", { name: name, prop1: prop1, prop2: prop2, prop3: prop3 }); },
    
    
    successComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
        _this.getAllProducts();
        _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },
    unsuccessComplete(value) {
      var _this = this;
      switch(value[0]) {
        case 'product-create':
          _this.changeRightView('product-list', '', '', '');
        break;

        default:
      }
    },

  },    
  components:{
    ScalingSquaresSpinner,
    
  },
  filters: {

  }
}
</script>

